/**
 * - Joins an array of strings with a line break and a specified separator.
 * - Default separator is '->'.
 * @param strings - Array of strings to be joined.
 * @param seperator - Separator to be used between lines. Before it "\n" = line break is added. Default is '->'.
 * @returns A single string with lines joined by line breaks and the specified separator.
 */

export default function lineBreak(strings: string[], seperator = "->") {
  const join = `\n${seperator} `;
  return strings.join(join);
}
